import React, { useState, useCallback, useContext } from "react";
import styled from "styled-components";
import EditPic from "../../../SVGs/Edit.svg";
import CustomTextField from "../../Common/CustomTextField";
import CustomRadioButton from "../../Common/CustomRadioButton";
import toast from "react-hot-toast";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import Cookies from "js-cookie";
import { UserContext } from "../../../Context/user_context";
import PageLoader from "../../Common/PageLoader";

function ContactInformation({ data, contactId, refetchData }) {
  const [isLoading, setIsLoading] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [contactInformation, setContactInformation] = useState(false);
  const [mobileTexting, setMobileTexting] = useState(true);
  const [email, setEmail] = useState(data ? data.emailaddress1 : "");
  const [mobilePhone, setMobilePhone] = useState(data ? data.mobilephone : "");
  const [homePhone, setHomePhone] = useState(data ? data.telephone2 : "");

  const handleContactInformation = useCallback(() => {
    setContactInformation(!contactInformation);
  }, [contactInformation]);

  const handleUpdateRecord = async () => {
    setIsLoading(true);
    const userid = contactId
      ? contactId
      : Cookies.get("hippocratic_portal_contactid");
    const recordData = {
      entity: "contacts",
      id: userid,
      attributes: [
        {
          fieldname: "emailaddress1",
          value: email,
          type: "string",
          entity: null,
        },
        {
          fieldname: "mobilephone",
          value: mobilePhone,
          type: "string",
          entity: null,
        },
        {
          fieldname: "telephone2",
          value: homePhone,
          type: "string",
          entity: null,
        },
        ...(user.hip_initialportalinfoupdate ? [] : [{
          fieldname: "hip_initialportalinfoupdate",
          value: "910310000",
          type: "optionset",
          entity: null,
        }])
      ],
    };

    try {
      await getApiClient().updateRecord(recordData);
      if (!user.hip_initialportalinfoupdate) {
        setUser({
          ...user,
          hip_initialportalinfoupdate: true
        });
      }
      toast.success("Information has been updated succesfully");
      // Refetch data to get updated information
      if (refetchData) {
        await refetchData();
      }
    } catch (error) {
      makeStandardApiErrorHandler((error) => toast.error(error));
    } finally {
      setContactInformation(!contactInformation);
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Sectoin>
        <TopPart>
          <SubTitle>Contact Information</SubTitle>
          {contactInformation ? (
            <Save onClick={handleUpdateRecord}>Save Changes</Save>
          ) : (
            <Edit
              onClick={() => {
                handleContactInformation();
              }}
            >
              Edit
              <img style={{ height: "19px" }} src={EditPic} alt="edit-icon" />
            </Edit>
          )}
        </TopPart>
        <BottomPart>
          <FieldsContainer>
            <CustomTextField
              Active={contactInformation}
              Title="Email (Personal):"
              value={email}
              onChange={setEmail}
            />
            <CustomTextField
              Active={contactInformation}
              Title="Mobile Phone:"
              value={mobilePhone}
              onChange={setMobilePhone}
            />
            <CustomTextField
              Active={contactInformation}
              Title="Home Phone:"
              value={homePhone}
              onChange={setHomePhone}
            />
          </FieldsContainer>
          <FieldsContainer>
            <CustomRadioButton
              Active={contactInformation}
              title={"Mobile Texting Opt-in:"}
              options={[true, false]}
              value={mobileTexting}
              onChange={setMobileTexting}
              message={"Choose \"No\" to unsubscribe from our text messaging service"}
            />
          </FieldsContainer>
        </BottomPart>
      </Sectoin>
    </>
  );
}

const Sectoin = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
`;

const TopPart = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

const Edit = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #87a9bf;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: 10px;
  text-decoration-line: underline;
`;

const BottomPart = styled.div`
  display: grid;
  min-height: 100px;
  gap: 30px;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: left;

  @media screen and (max-width: 450px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;

const SubTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const FieldsContainer = styled.div`
  gap: 5px;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const Save = styled.div`
  border-radius: 300px;
  background: #304961;
  padding: 5px 10px;

  cursor: pointer;

  white-space: nowrap;

  color: #fff;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

export default ContactInformation;
